import * as React from 'react';
import PropTypes from 'prop-types';

const SvgLogosFacebookSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M20.015 3H3.992A.993.993 0 003 3.991v16.005c0 .546.445.99.992.99h8.622v-6.963h-2.348v-2.717h2.348V9.31c0-2.326 1.423-3.586 3.495-3.586.991 0 1.848.074 2.098.107v2.427H16.77c-1.127 0-1.35.533-1.35 1.322v1.732h2.692l-.35 2.717H15.42V21h4.588a.993.993 0 00.992-.991V3.991A.983.983 0 0020.015 3z" />
    </svg>
  )
);
SvgLogosFacebookSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgLogosFacebookSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgLogosFacebookSmall;
